import script from "./Form10.vue?vue&type=script&setup=true&lang=js"
export * from "./Form10.vue?vue&type=script&setup=true&lang=js"

import "./Form10.vue?vue&type=style&index=0&id=3c9801e0&lang=less&scoped=true"

import exportComponent from "/Users/a/k618/work/sxdsjtj/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c9801e0"]])

export default __exports__